// extracted by mini-css-extract-plugin
export default {"bolo__quadro":"Descricao_bolo__quadro__flOZ4"};